import { useScgpUserFirstLoginUpdateMutation } from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { parse as parseQs } from "qs";
import React, { useState } from "react";

import { ResetPasswordPageFormData } from "../components/ResetPasswordPage";
import UpdateEmailPage from "../components/UpdateEmailPage";
import { setTokens } from "../utils";

const UpdateEmailView: React.FC = () => {
  const navigate = useNavigator();
  const [errors, setErrors] = useState([]);
  const qs = parseQs(location.search.substr(1));

  const [login] = useScgpUserFirstLoginUpdateMutation({
    onCompleted: data => {
      if (!data?.scgpUserFirstLoginUpdate?.errors?.length) {
        setTokens(
          data?.scgpUserFirstLoginUpdate?.token,
          data?.scgpUserFirstLoginUpdate?.csrfToken,
          data?.scgpUserFirstLoginUpdate?.refreshToken,
          false
        );
        navigate("/", { replace: true });
      }
      setErrors(data.scgpUserFirstLoginUpdate.errors as any);
    }
  });

  const handleSubmit = (data: ResetPasswordPageFormData) =>
    login({
      variables: {
        tempToken: qs?.token,
        email: data?.email,
        username: qs?.username
      }
    });

  return (
    <UpdateEmailPage
      disabled={false}
      errors={errors}
      onBack={() => navigate("/")}
      onSubmit={handleSubmit}
    />
  );
};
export default UpdateEmailView;
